import { createRouter, createWebHashHistory } from 'vue-router'
import root from './root'
import login from './login'
import content from './content'
import home from './home'
import { usePageView } from '@Utils/hook/usePageTrack'

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 }
  },
  routes: [].concat(root, login, content, home),
  history: createWebHashHistory()
})

const originalPush = router.push
const originalReplace = router.replace

router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}

// 全局前置函数
router.beforeEach((to, from, next) => {
  const dom = document.getElementById('content-main')
  if (dom) {
    dom.scrollTo({ top: 0, behavior: 'instant' })
  }
  return next()
})

// 全局后置函数
router.afterEach((to, from) => {})

usePageView(router)

export default router
